export default __webpack_public_path__ + "static/media/11.5c81b792.png";